import React, {useEffect, useState} from 'react';
import BackServer from "../../api/BackServer";
import {Image, Spin, Tag, Modal, Card, Row, Col, Statistic} from "antd";
import { LoadingOutlined, PlayCircleOutlined } from '@ant-design/icons';
import VideoPlayer from '../reviews/VideoPlayer';

const ReviewDetail = (props) => {
    const [orderDetails, setOrderDetails] = useState(undefined);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [videoModalVisible, setVideoModalVisible] = useState(false);

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                console.log(props.dta);
                const data = await BackServer.get_orderDetails(props.dta.uuid, props.dta.comments_amount);
                console.log(data.data);
                setOrderDetails(data.data);
            } catch (error) {
                console.error('Ошибка при получении деталей заказа:', error);
            }
        };
        fetchDetails();
    }, [props.dta]);

    const handleVideoClick = (video) => {
        setSelectedVideo(video);
        setVideoModalVisible(true);
    };

    const handleCloseVideo = () => {
        setVideoModalVisible(false);
        setSelectedVideo(null);
    };

    return (
        <>
            <div key={props.dta.uuid} style={{
                marginTop: '16px',
                padding: '12px',
                borderLeft: '3px solid #1890ff',
                backgroundColor: '#f6f9ff',
                borderRadius: '6px'
            }}>
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                    <img
                        src={props.dta.product.cover_image}
                        alt="avatar"
                        style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            marginRight: '10px'
                        }}
                    />
                    <div>
                        <div style={{fontWeight: 600}}>{props.dta.author_name}</div>
                        <div style={{fontSize: '12px', color: '#888'}}>
                            {new Date(props.dta.published_at).toLocaleDateString('ru-RU')}
                        </div>
                    </div>
                </div>
                <div style={{fontSize: '15px'}}>{props.dta.text.comment}</div>
            </div>
            {(orderDetails == undefined) ? (
                    <h2><Spin indicator={<LoadingOutlined style={{fontSize: 48}} spin/>}/></h2>) :
                (
                    <>
                        <div>
                            <h3 style={{color: "#667085"}}>Медиа</h3>
                            <div style={{display: "flex", gap: "12px", flexWrap: "wrap"}}>
                                {/* Photos */}
                                {orderDetails.photos.map((photo, index) => (
                                    <Image
                                        key={`photo-${index}`}
                                        width={100}
                                        height={100}
                                        src={photo.url}
                                        style={{borderRadius: "8px", objectFit: "cover"}}
                                    />
                                ))}

                                {/* Videos */}
                                {orderDetails.videos?.map((video, index) => (
                                    <div
                                        key={`video-${video.uploadId}`}
                                        style={{
                                            position: 'relative',
                                            width: 100,
                                            height: 100,
                                            cursor: 'pointer',
                                            borderRadius: "8px",
                                            overflow: 'hidden'
                                        }}
                                        onClick={() => handleVideoClick(video)}
                                    >
                                        <Image
                                            src={video.previewUrl}
                                            width={100}
                                            height={100}
                                            style={{
                                                objectFit: "cover"
                                            }}
                                            preview={false}
                                        />
                                        <div style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            background: 'rgba(0, 0, 0, 0.5)',
                                            borderRadius: '50%',
                                            width: '32px',
                                            height: '32px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <PlayCircleOutlined style={{ fontSize: '20px', color: '#fff' }} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {/*{orderDetails.uuid}*/}
                        <div style={{paddingTop: "10px"}}>
                            <Tag color="green-inverse">{orderDetails.visibility}</Tag>
                        </div>

                        <p>
                            {(orderDetails.answers?.length < 1) ? (
                                <>
                                    <span style={{fontSize: '17px'}}>Количество ответов: </span>
                                    <Tag color="red-inverse">Нет</Tag>
                                </>
                            ) : (
                                <>
                                    {orderDetails.answers?.map((answer, index) => (
                                        <div key={index} style={{
                                            marginTop: '16px',
                                            padding: '12px',
                                            borderLeft: '3px solid #1890ff',
                                            backgroundColor: '#f6f9ff',
                                            borderRadius: '6px'
                                        }}>
                                            <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                                                <img
                                                    src={answer.author.avatar_uri}
                                                    alt="avatar"
                                                    style={{
                                                        width: '36px',
                                                        height: '36px',
                                                        borderRadius: '50%',
                                                        marginRight: '10px'
                                                    }}
                                                />
                                                <div>
                                                    <div style={{fontWeight: 600}}>{answer.author.name}</div>
                                                    <div style={{fontSize: '12px', color: '#888'}}>
                                                        {new Date(answer.published_at).toLocaleDateString('ru-RU')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{fontSize: '15px'}}>{answer.text}</div>
                                            <div style={{marginTop: '8px'}}>
                                                {answer.is_published ? (
                                                    <Tag color="success">Опубликован</Tag>
                                                ) : (
                                                    <>
                                                        <Tag color="error">Не опубликован</Tag>
                                                        {answer.status && (
                                                            <Tag color="warning" style={{marginLeft: '8px'}}>
                                                                Причина: {answer.status}
                                                            </Tag>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </p>

                        {/* Video Modal */}
                        <Modal
                            open={videoModalVisible}
                            onCancel={handleCloseVideo}
                            footer={null}
                            width={800}
                            title="Просмотр видео"
                            destroyOnClose={true}
                            centered
                            style={{ top: 20 }}
                        >
                            {selectedVideo && (
                                <div style={{
                                    width: '100%',
                                    aspectRatio: '16/9',
                                    maxHeight: 'calc(100vh - 200px)',
                                    overflow: 'hidden'
                                }}>
                                    <VideoPlayer
                                        url={selectedVideo.url}
                                        poster={selectedVideo.previewUrl}
                                    />
                                </div>
                            )}
                        </Modal>
                    </>
                )}
        </>
    );
};

export default ReviewDetail;